






























































































































































import { Component, Vue } from 'vue-property-decorator'

@Component
export default class FormPage extends Vue {
  created () {
    // console.log('form created')
  }

  mounted () {
    // console.log('form mounted')
  }
}
